module.exports = __webpack_public_path__ + "media/images/icon__link@2x-1de4d4ba39923c0d1604ac6c581bdafa.png";